import { createMiddleware, createMetaReducer } from 'redux-beacon'
import { GoogleTagManager } from 'redux-beacon/targets/google-tag-manager'

import { buyTokensThunk } from 'modules/contracts'

const buyTokens = ({ payload: { json: contract } }) => ({
  ecommerce: {
    currencyCode: contract.currency,
    purchase: {
      actionField: {
        id: contract.contract.id,
        affiliation: contract.coin_name,
        revenue: contract.revenue,
        tax: '0',
        shipping: '0',
        coupon: ''
      },
      products: [
        {
          name: contract.coin_name,
          id: contract.contract.id,
          price: contract.coin_price,
          brand: contract.coin_name,
          category: contract.coin_name,
          variant: contract.coin_name,
          quantity: contract.contract.info.coin_amount,
          coupon: ''
        }
      ]
    }
  },
  event: 'gtm-ee-event',
  'gtm-ee-event-category': 'Enhanced Ecommerce',
  'gtm-ee-event-action': 'Purchase',
  'gtm-ee-event-non-interaction': 'False'
})

const eventsMap = {
  [buyTokensThunk.SUCCEEDED]: buyTokens
}

export const middleware = createMiddleware(eventsMap, GoogleTagManager())
export const metaReducer = createMetaReducer(eventsMap, GoogleTagManager())



// WEBPACK FOOTER //
// ./src/gtm.js